export enum PRODUCT_CARD_SIZES {
    DEFAULT,
    EXTRA_SMALL,
}
